// no definitions types for this library
import Loading from 'vue-loading-overlay';

export function useLoading(Vue) {
  Vue.use(Loading);
}
